import React from "react";
import { Outlet, matchPath, useLocation } from "react-router-dom";

import Screen from "./Screen";
import { PROTECTED_ROUTES } from "../routing/exportRoutes";
import {
  TitleProvider,
  useSetRouteTitle,
  useTitleValue,
} from "./titleContext";

const findRouteTitle = (pathname: string): string => {
  for (const r of PROTECTED_ROUTES) {
    if (matchPath({ path: r.path, end: true }, pathname)) {
      return r.title ?? "";
    }
  }
  return "";
};

const LayoutBody: React.FC = () => {
  const { pathname } = useLocation();
  useSetRouteTitle(findRouteTitle(pathname));

  const title = useTitleValue();

  return (
    <Screen title={title}>
      <Outlet />
    </Screen>
  );
};

const DashboardLayout: React.FC = () => (
  <TitleProvider>
    <LayoutBody />
  </TitleProvider>
);

export default DashboardLayout;
